import {
  HiddenElementsCounter,
  LabelChip,
  OverflowCounter,
  OverflowItemTypography,
  ExternalLink,
  Typography,
  tokens,
} from '@cast/design-system';

import { CUSTOM_EDGE_PROVIDER } from '../constants';
import { EdgeLocationMappedState, EnhancedEdgeLocation } from '../types';

type NodeTemplatesCellProps = {
  edgeLocation: EnhancedEdgeLocation;
  nodeTemplatesLink: string;
};

export const NodeTemplatesCell = ({
  edgeLocation,
  nodeTemplatesLink,
}: NodeTemplatesCellProps) => {
  const { mappedState, provider, templateUsage } = edgeLocation;

  if (
    provider === CUSTOM_EDGE_PROVIDER ||
    (mappedState !== EdgeLocationMappedState.Ready &&
      mappedState !== EdgeLocationMappedState.InUse)
  ) {
    return <span>-</span>;
  }

  if (mappedState === EdgeLocationMappedState.Ready) {
    return (
      <ExternalLink
        link={nodeTemplatesLink}
        onClick={(e) => e.stopPropagation()}
      >
        Add to a template
      </ExternalLink>
    );
  }

  const templateNames = templateUsage.templateNames;

  return (
    <OverflowCounter typography="inherit" display="flex">
      <Typography noWrap variant="inherit">
        {templateNames.map((name, index) => (
          <OverflowItemTypography
            overflowKey={name + index}
            key={name + index}
            variant="inherit"
            component="span"
          >
            <ExternalLink
              link={nodeTemplatesLink}
              noIcon
              onClick={(e) => e.stopPropagation()}
              sx={{ display: 'inline' }}
            >
              {name}
              {index < templateNames.length - 1 ? ', ' : ''}
            </ExternalLink>
          </OverflowItemTypography>
        ))}
      </Typography>

      <HiddenElementsCounter>
        {(count) =>
          count ? (
            <LabelChip
              sx={{
                backgroundColor: tokens.theme.bg.categorical.blueStrong,
                color: tokens.theme.fg.categorical.onBlueStrong,
                marginLeft: 4,
                '& .DsChip-Content': { cursor: 'pointer' },
              }}
              size="sm"
            >
              {count}
            </LabelChip>
          ) : null
        }
      </HiddenElementsCounter>
    </OverflowCounter>
  );
};
